var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"exam__container"},[_vm._t("default")],2),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }